import React from 'react'
import Icon from '@mdi/react'
import {
    mdiCheckCircleOutline,
    mdiAlertCircleOutline,
    mdiCloseCircleOutline,
    mdiFlashOutline,
    mdiConnection,
    mdiLightningBoltOutline,
    mdiBugOutline
} from '@mdi/js'
import { getReportStatus } from '../../../../utils'
import { REPORT_STATUSES } from '../../../reports/constants'
import { OPERATION_MODES } from '../../constants'
import { Icon as MuiIcon } from '@material-ui/core'
import RodentCriticalIcon from '../../../../assets/svg/rodent-critical-icon.svg'
import DownCriticalIcon from '../../../../assets/svg/down-critical-icon.svg'

export default function ReportStatus(props) {
    const { theme, report, size = 1 } = props
    const operationMode = report?.device_operation_mode
    const iconSizePx = size * 24

    switch (getReportStatus(report)) {
        case REPORT_STATUSES.infested:
            if (operationMode === OPERATION_MODES.snaptrap) {
                return (
                    <Icon
                        path={mdiFlashOutline}
                        size={`${iconSizePx}px`}
                        color={theme.error}
                    />
                )
            }
            return (
                <Icon
                    path={mdiCloseCircleOutline}
                    size={`${iconSizePx}px`}
                    color={theme.error}
                />
            )

        case REPORT_STATUSES.critical:
            return (
                <Icon
                    path={mdiCloseCircleOutline}
                    size={`${iconSizePx}px`}
                    color={theme.error}
                />
            )
        case REPORT_STATUSES.down:
            return (
                <MuiIcon>
                    <img
                        src={DownCriticalIcon}
                        width={iconSizePx}
                        height={iconSizePx}
                    />
                </MuiIcon>
            )
        case REPORT_STATUSES.catch:
            return (
                <MuiIcon>
                    <img
                        src={RodentCriticalIcon}
                        width={iconSizePx}
                        height={iconSizePx}
                    />
                </MuiIcon>
            )
        case REPORT_STATUSES.warning:
            return (
                <Icon
                    path={mdiAlertCircleOutline}
                    size={`${iconSizePx}px`}
                    color={theme.warning}
                />
            )
        case REPORT_STATUSES.info:
            return (
                <Icon
                    path={mdiCheckCircleOutline}
                    size={`${iconSizePx}px`}
                    color={theme.active}
                />
            )
        default:
            return (
                <Icon
                    path={mdiCheckCircleOutline}
                    size={`${iconSizePx}px`}
                    color={theme.active}
                />
            )
    }
}
